import { Modal } from '../ui/Modal';
import { Spinner } from '../ui/Spinner';

interface ReactionUser {
  id: string;
  message_id: string;
  user_id: string;
  username: string;
  emoji: string;
  created_at: string;
}

interface WhoReactedModalProps {
  show: boolean;
  emoji: string;
  users: ReactionUser[];
  loading: boolean;
  onClose: () => void;
}

export function WhoReactedModal({ show, emoji, users, loading, onClose }: WhoReactedModalProps) {
  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  return (
    <Modal isOpen={show} onClose={onClose} title={`Reacted with ${emoji}`}>
      {loading ? (
        <div className="text-center py-4">
          <Spinner />
        </div>
      ) : users.length === 0 ? (
        <div className="text-center text-slate-400 py-4">No reactions found</div>
      ) : (
        <div className="space-y-2">
          {users.map((user) => (
            <div
              key={user.id}
              className="flex items-center justify-between p-2 bg-slate-900/50 rounded"
            >
              <span className="text-white">{user.username}</span>
              <span className="text-xs text-slate-400">{formatDate(user.created_at)}</span>
            </div>
          ))}
        </div>
      )}
    </Modal>
  );
}
